import { useState } from 'react';
import { SVGPureIcon } from '@/ui';
import Tooltip from '@/ui/tooltip';
import { HelpOther } from '@/common/helper';
import globalStore from '@/store/global';

const CopyBtn = ({ data, inviteCodeValid, inviteCodeDisabledText }) => {
  const { code, max_uses, used_count } = data;
  const [copyComplete, setCopyComplete] = useState(false);

  const handleCopy = () => {
    // 已分享完 或 资源紧张,不能使用复制功能
    if(used_count >= max_uses || !inviteCodeValid) {
      return;
    }

    const text = `您的专属助力码：${code} 

请访问官方下载页面：
https://bot.n.cn/download?src=AIBotCode

完成以下步骤即可体验全新功能：
1. 下载并安装纳米AI客户端
2. 进入首页或智能体页
3. 在页面右上角点击【输入助力码】按钮，打开弹窗，输入您的专属助力码

成功验证后，您和分享者都将获得${globalStore.cloudConfig?.assistantMcpServerConfig?.invited_count}次额外使用机会！`
    
    navigator.clipboard.writeText(text);
    
    HelpOther.toast('复制成功');

    // 复制状态更新
    setCopyComplete(true);
    setTimeout(() => {
      setCopyComplete(false);
    }, 1000);
  };

  const getTooltipTitle = () => {
    if(used_count >= max_uses) {
      return '当前邀请码已分享完';
    }

    if(!inviteCodeValid) {
      return inviteCodeDisabledText || '当前资源紧张，邀请码暂停使用';
    }
    return '邀请好友体验限免智能体，它可以执行研究任务，进行数据分析，撰写报告，生成动态网页';
  };

  return (
    <Tooltip title={getTooltipTitle()}>
      <button className="w-28px h-28px flex justify-center items-center hover:bg-[rgba(0,0,0,0.03)] rounded-8px" onClick={handleCopy}>
        {copyComplete ? (
          <SVGPureIcon name="icon_complete" size={20} iconClass="opacity-50" />
        ) : (
          <SVGPureIcon name="copy" size={28}/>
        )}
      </button>
    </Tooltip>
  );
};

export default CopyBtn;
